import { useFetchPaginatedData } from "@hooks/api/useFetchPaginatedData";
import { GetAllUsuarios } from "@services/Usuario/Index";

export function useFetchDataGerentes() {
    // Usa o hook genérico para buscar todos os gerentes
    const { data, loading, fetchAllData } = useFetchPaginatedData(GetAllUsuarios, 50, { perfil: "GERENTE"});

    return {
       gerentesOptions: data.map((item) => ({
           value: item.id,
           label: item.nome,
       })).sort((a, b) => a.label.localeCompare(b.label)),
       gerenteLoading: loading,
       fetchGerentes: fetchAllData,
    };
}
